import styledC from 'styled-components';

const TriggerWrapper = styledC.div`
  display: block;
`;

export default TriggerWrapper;
